// Import styles
import '../css/index.css';

// Import HTMX
import 'htmx.org';

// Configure HTMX with CSRF token
import './htmx-config';

// Auto-register all Stimulus controllers
import './controllers';
